import { EApiSortType } from '@/api/apiConstants'

const MEAL_ADDON_CATEGORIES_QUERY_KEY = 'meal-addon-categories' as const
const addonCategoryQueryKey = { ...useQueryKeyFactory(MEAL_ADDON_CATEGORIES_QUERY_KEY) }

const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_ADDON_CATEGORIES)

export const apiAddonCategories = {
	fetchAddonCategories: async (): Promise<IApiResponseModel<IAddonCategoryModel[]>> => {
		const fetchFn = async () => {
			const { data, meta } = await apiCommon<IAddonCategory[]>(`${groupPrefix}`, {
				method: 'GET',
				...createQuery(null, null, { created_at: EApiSortType.ASC }),
			})

			return { data: data.map(d => AddonCategory(d)), meta }
		}

		const config = () => ({
			queryKey: addonCategoryQueryKey.list(),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<IApiResponseModel<IAddonCategoryModel[]>>(config)
	},
	createAddonCategory: async (payload: IAddonCategoryCreatePayload): Promise<IAddonCategoryModel> => {
		const { data } = await apiCommon<IAddonCategory>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		useQueryClientService().invalidateQueries(addonCategoryQueryKey.lists())

		return AddonCategory(data)
	},
	updateAddonCategory: async (id: number, payload: IAddonCategoryUpdatePayload): Promise<IAddonCategoryModel> => {
		const { data } = await apiCommon<IAddonCategory>(`${groupPrefix}/${id}`, {
			method: 'PUT',
			body: payload,
		})

		useQueryClientService().invalidateQueries(addonCategoryQueryKey.lists())

		return AddonCategory(data)
	},
	deleteAddonCategory: async (id: number): Promise<void> => {
		await apiCommon<string>(`${groupPrefix}/${id}`, { method: 'DELETE' })

		useQueryClientService().invalidateQueries(addonCategoryQueryKey.lists())
	},
}
